import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CreateProjectReportComponent } from './create-project-report.component';

const routes: Routes = [
  {
    path: '',
    component: CreateProjectReportComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CreateProjectReportRoutingModule { }
